import { render, staticRenderFns } from "./BaseLabelDialog.vue?vue&type=template&id=4263eca4&scoped=true&"
import script from "./BaseLabelDialog.vue?vue&type=script&lang=js&"
export * from "./BaseLabelDialog.vue?vue&type=script&lang=js&"
import style0 from "./BaseLabelDialog.vue?vue&type=style&index=0&id=4263eca4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4263eca4",
  null
  
)

export default component.exports